import { useTranslation } from "react-i18next";

export const OrSeparator = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-center gap-6">
      <hr className="flex-1 border-border-tertiary" />
      <span className="text-xs font-semibold leading-none tracking-[0.24px] text-foreground-secondary">
        {t("portal:common.or")}
      </span>
      <hr className="flex-1 border-border-tertiary" />
    </div>
  );
};
